import {memo, StyleSheet, Text, View} from "shared/base"
import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import {digs} from "diggerize"
import EventEmitter from "events"
import {HelperText} from "react-native-paper"
import {Pressable} from "react-native"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import useEventEmitter from "@kaspernj/api-maker/build/use-event-emitter"
import {useForm} from "@kaspernj/api-maker/build/form"
import useInput from "@kaspernj/api-maker/build/use-input"

const events = new EventEmitter()

const styles = StyleSheet.create({
  labelContainer: {marginLeft: 12}
})

export default memo(shapeComponent(class ComponentsUtilsRadioButton extends ShapeComponent {
  static defaultProps = {
    checked: null
  }

  static propTypes = propTypesExact({
    checked: PropTypes.bool,
    dataSet: PropTypes.object,
    defaultChecked: PropTypes.bool,
    fontStyle: PropTypes.object,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onChangeChecked: PropTypes.func,
    style: PropTypes.object,
    testID: PropTypes.string,
    value: PropTypes.any
  })

  setup() {
    const {checked, name, value} = this.props
    const {wrapperOpts} = useInput({props: this.props, wrapperOptions: {type: "input"}})
    const {errors} = digs(wrapperOpts, "errors")
    let isChecked

    if ("defaultChecked" in this.props && (this.p.defaultChecked === true || this.p.defaultChecked === false)) {
      isChecked = this.p.defaultChecked
    } else {
      isChecked = checked
    }

    this.errors = errors
    this.form = useForm()

    // Set initial value in form
    useMemo(() => {
      if (this.form && isChecked && name) {
        this.form.setValue(name, value)
      }
    }, [])

    this.useStates({
      checked: isChecked
    })

    useEventEmitter(events, `onAnyRadioButtonChecked${name}`, this.tt.onAnyRadioButtonChecked)
  }

  render() {
    const {errors} = this.tt
    const {dataSet, fontStyle, label, style, testID} = this.props
    let checked

    if (this.p.checked !== null) {
      checked = this.p.checked
    } else {
      checked = this.s.checked
    }

    const actualDataSet = useMemo(() => Object.assign({}, dataSet, {checked}), [checked])

    const pressableStyle = useMemo(() => {
      const pressableStyle = Object.assign({}, style, {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      })

      return pressableStyle
    }, [style])

    const viewStyle = useMemo(() => {
      const viewStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 17,
        height: 17,
        backgroundColor: "#cbcbcb",
        borderRadius: "50%"
      }

      if (checked) {
        viewStyle.backgroundColor = "#5253ff"
      }

      return viewStyle
    }, [checked])

    return (
      <Pressable dataSet={actualDataSet} onPress={this.tt.onRadioButtonPressed} style={pressableStyle} testID={testID}>
        <View style={viewStyle} />
        {label &&
          <View style={styles.labelContainer}>
            <Text style={fontStyle}>
              {label}
            </Text>
          </View>
        }
        {errors.length > 0 &&
          <HelperText dataSet={this.helperTextDataSet ||= {class: "errors-helper-text"}} type="error">
            {this.errorMessages().join(". ")}
          </HelperText>
        }
      </Pressable>
    )
  }

  onAnyRadioButtonChecked = ({value}) => {
    if (value != this.props.value && this.s.checked) {
      this.setState({checked: false})
    }
  }

  onRadioButtonPressed = () => {
    const {form} = this.tt
    const {name, value} = this.props
    const newChecked = !this.p.checked

    if (form && name) {
      form.setValue(name, value !== undefined ? value : newChecked)
    }

    if (this.props.onChange) {
      this.p.onChange({
        checked: newChecked,
        label: this.p.label,
        value: this.props.value
      })
    }

    if (this.props.onChangeChecked) {
      this.p.onChangeChecked(newChecked)
    }

    this.setState({checked: newChecked})

    events.emit(`onAnyRadioButtonChecked${name}`, {
      value
    })
  }
}))
